<template>
  <div>
    <Head :title="$t('actions.associate_model', [$t('models.user')])"/>

    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.members.index')">
          {{ $t('models.member') }}
        </Link>
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ $t('actions.associate_model', [$t('models.user')]) }}: {{ member.display_name }}
      </h1>
      <div class="ml-auto">
        <Link class="inline-block btn-indigo" :href="route('admin.members.edit', member.uuid)">
          <span>{{ $t('ui.back') }}</span>
        </Link>
      </div>
    </div>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.user_uuid" :error="form.errors.user_uuid"
                        class="pb-8 pr-6 w-full" :label="$t('labels.existing_model', [$t('models.user')])">
            <option :value="null"/>
            <option v-for="user in users" :value="user.uuid">
              {{ [user.name, user.mobile, user.email].filter(a => a).join(' / ') }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ $t('actions.save') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import FileInput from '@/Inputs/FileInput'
import TextInput from '@/Inputs/TextInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Inputs/TextareaInput";

export default {
  components: {
    TextareaInput,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    member: Object,
    users: Array,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        user_uuid: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(route('admin.members.associate-user.store', this.member.uuid))
    },
  },
}
</script>
